import React, { useEffect, useRef, useState } from "react";
import { getUserSession } from "../component/userInfo";
import { Button, Form, Row, Card, CloseButton, Badge } from "react-bootstrap";
import styled from "styled-components";
import { ItemTypes } from "../component/ItemTypes";
import { useDrag, useDrop } from "react-dnd";

const MyButton = styled.div`
  .close-delete {
    padding: 12px;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
  }
`;

const PhotoItem = ({
  imageInfo,
  photoNo,
  index,
  movePhotoItem,
  width,
  mainButtonView,
  reloadPhotoList,
}) => {
  const ref = useRef(null);

  const [image, setImage] = useState(imageInfo);
  const [viewImage, setViewImage] = useState(true);
  const [photoContent, setPhotoContent] = useState(imageInfo.photo_content);
  const [originalPhotoContent, setOriginalPhotoContent] = useState(
    imageInfo.photo_content
  );
  const [maxWidth, setMaxWidth] = useState(width + "px");
  useEffect(() => {
    setMaxWidth(width + "px"); // prop 변경시 state변경
    // console.log("useEffect ", width);
  }, [width]);

  // useDrop: 이 컴포넌트 위로 다른 카드가 드래그되면 호출됨
  const [, drop] = useDrop({
    accept: ItemTypes.PHOTO, // 같은 타입의 항목만 드롭 받음
    hover(item, monitor) {
      //console.log(item);
      if (!ref.current) return;
      // console.log("1>>>>>>>>");
      const dragIndex = item.index;
      const hoverIndex = index;
      // 같은 카드 위에서는 아무 동작 안함
      if (dragIndex === hoverIndex) return;
      // console.log("2 dragIndex === hoverIndex 통과 >>>>>>>>");
      // 카드의 화면상 위치(rect) 정보 계산
      const hoverBoundingRect = ref.current.getBoundingClientRect();
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      // 마우스 커서의 현재 위치
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      // 아래쪽으로 드래그 중일 때, 아직 절반 아래로 내려오지 않았으면 위치 변경 안함
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      // console.log("3 dragIndex < hoverIndex && hoverClientY < hoverMiddleY통과 >>>>>>>>");
      // 위쪽으로 드래그 중일 때, 아직 절반 위로 올라오지 않았으면 위치 변경 안함
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      // console.log("4 dragIndex > hoverIndex && hoverClientY > hoverMiddleY 통과 >>>>>>>>");
      // 위치 교환 수행
      movePhotoItem(dragIndex, hoverIndex);
      // 드래그 중인 아이템의 인덱스를 최신 값으로 업데이트
      item.index = hoverIndex;
    },
  });
  // useDrag: 이 컴포넌트를 드래그 가능한 요소로 만듦
  const [{ isDragging }, drag] = useDrag(() => ({
    type: ItemTypes.PHOTO,
    item: () => ({ image, index }),
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  const deleteImage = (event) => {
    if (window.confirm("해당 이미지를 삭제하시겠습니까?")) {
      const userSession = getUserSession();
      const formData = new FormData();
      formData.append("uid", userSession.uid);
      formData.append("action", "delImg");
      formData.append("photoNo", photoNo);
      formData.append("photoFileNo", image.photo_file_no);
      fetch("https://work.wekoinonia.org/json/photo.php", {
        method: "POST",
        body: formData,
        mode: "cors",
        //headers: new Headers({
        //'Content-Type': 'application/json'
        //  'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      })
        .then((res) => {
          return res.json(); //Promise 반환
        })
        .then((json) => {
          console.log(json); // 서버에서 주는 json데이터가 출력 됨
          if (json.code === "0000") {
            setViewImage(false);
          }
          alert(json.msg);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  };
  const updateComment = (event) => {
    const userSession = getUserSession();
    const formData = new FormData();
    formData.append("uid", userSession.uid);
    formData.append("action", "updateComment");
    formData.append("photoNo", photoNo);
    formData.append("photoFileNo", image.photo_file_no);
    formData.append("photoContent", photoContent);
    fetch("https://work.wekoinonia.org/json/photo.php", {
      method: "POST",
      body: formData,
      mode: "cors",
      //headers: new Headers({
      //'Content-Type': 'application/json'
      //  'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    })
      .then((res) => {
        return res.json(); //Promise 반환
      })
      .then((json) => {
        console.log(json); // 서버에서 주는 json데이터가 출력 됨
        if (json.code === "0000") {
          setOriginalPhotoContent(photoContent); // 동기화
        } else {
          alert(json.msg);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const onSubmitComment = (event) => {
    event.preventDefault();
    console.log("==================");
    console.log(event);
    updateComment(event);
  };
  const changeMainPhotoNo = (event) => {
    const userSession = getUserSession();
    if (window.confirm("해당 이미지를 메인으로 설정하시겠습니까?")) {
      const formData = new FormData();
      formData.append("uid", userSession.uid);
      formData.append("action", "changeMainPhotoNo");
      formData.append("photoNo", photoNo);
      formData.append("mainPhotoNo", image.photo_file_no);
      formData.append("photoContent", photoContent);
      fetch("https://work.wekoinonia.org/json/photo.php", {
        method: "POST",
        body: formData,
        mode: "cors",
        //headers: new Headers({
        //'Content-Type': 'application/json'
        //  'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      })
        .then((res) => {
          return res.json(); //Promise 반환
        })
        .then((json) => {
          console.log(json); // 서버에서 주는 json데이터가 출력 됨
          if (json.code === "0000") {
            reloadPhotoList();
          } else {
            alert(json.msg);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  };

  let imgsrc = image.imgsrc.startsWith("http")
    ? image.imgsrc
    : "https://work.wekoinonia.org" + image.imgsrc;

  // 드래그와 드롭을 함께 지원하려면 ref를 drag와 drop 함수에 할당
  drag(drop(ref));

  return (
    <>
      {viewImage && (
        <Row
          className="mb-1"
          ref={ref}
          style={{
            opacity: isDragging ? 0.5 : 1,
            // padding: "8px",
            // margin: "4px",
            // backgroundColor: "lightgray",
            cursor: "move",
          }}
        >
          <Form onSubmit={onSubmitComment}>
            <Card style={{ minWidth: "18rem", maxWidth: maxWidth }}>
              <MyButton>
                <CloseButton onClick={deleteImage} className="close-delete" />
              </MyButton>
              <Card.Img variant="top" src={imgsrc} />
              <Card.Body>
                {imageInfo.main_photo_yn && (
                  <Card.Title>
                    <Badge bg="secondary">
                      목록에 표시되는 메인사진입니다.
                    </Badge>
                  </Card.Title>
                )}
                <Card.Text>
                  <Form.Control
                    size="sm"
                    type="textarea"
                    placeholder="사진설명"
                    value={photoContent}
                    onChange={(e) => setPhotoContent(e.target.value)}
                  />
                </Card.Text>
                {photoContent != originalPhotoContent && (
                  <Button
                    variant="primary"
                    type="submit"
                    className=""
                    size="sm"
                  >
                    수정
                  </Button>
                )}
                {mainButtonView && !imageInfo.main_photo_yn && (
                  <Button
                    variant="primary"
                    type="button"
                    className=""
                    size="sm"
                    onClick={(e) => changeMainPhotoNo(e.target.value)}
                  >
                    메인으로
                  </Button>
                )}
              </Card.Body>
            </Card>
          </Form>
        </Row>
      )}
    </>
  );
};

export default PhotoItem;
